import { render, staticRenderFns } from "./PartnerExchangeCard.vue?vue&type=template&id=c92a365c&scoped=true"
import script from "./PartnerExchangeCard.vue?vue&type=script&lang=ts"
export * from "./PartnerExchangeCard.vue?vue&type=script&lang=ts"
import style0 from "./PartnerExchangeCard.vue?vue&type=style&index=0&id=c92a365c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92a365c",
  null
  
)

export default component.exports